import React from "react"
import { Link } from "react-router-dom"
import { ProjectFiles } from "./ProjectFiles"
import ProjectSubmitAdmin from "./ProjectSubmitAdmin"
import { ProjectProcess } from "./ProjectProcess"
import ProjectDelete from "./ProjectDelete"
import ProjectUpdate from "./ProjectUpdate"
import {
  Tag,
  Tooltip,
  Space,
  Typography,
  Badge,
  Flex,
  Divider,
  Button,
} from "antd"
import ResetPackage from "./ResetPackage"
import { StopGasProject } from "./StopGasProject"
import { ProjectRequired } from "./ProjectRequired"
import PrepareForMap from "./PrepareForMap"
import ProjectSendToGas from "./ProjectSendToGas"
import { getFormattedAmount } from "helpers/utilities"
import {
  CalendarOutlined,
  UserOutlined,
  HomeOutlined,
  EnvironmentOutlined,
  NumberOutlined,
  WalletOutlined,
  FileTextOutlined,
  BuildOutlined,
  ToolOutlined,
  EyeOutlined,
  CustomerServiceOutlined,
  HistoryOutlined,
} from "@ant-design/icons"

const { Text } = Typography

export const renderFileButton = (row, { props, setErrorMessage }) => {
  return (
    <ProjectFiles
      rowData={row}
      mainProps={props}
      setErrorMessage={setErrorMessage}
    />
  )
}

export const renderFloorNumber = row => {
  if (row.floorNumber == 0 && row.unitNumber == 1)
    return (
      <Tag color="cyan" style={{ fontSize: 10, margin: 0 }}>
        همکف
      </Tag>
    )
  if (row.floorNumber == 0 && row.unitNumber > 1)
    return (
      <Tag color="purple" style={{ fontSize: 10, margin: 0 }}>
        چند واحدی
      </Tag>
    )
  return <Tag style={{ fontSize: 10, margin: 0 }}>طبقه {row.floorNumber} </Tag>
}

export const renderExeFullName = (row, props) => {
  return row.executor.fullName
}

export const renderProjectProcess = (row, { props }) => {
  return <ProjectProcess rowData={row} mainProps={props} />
}

export const renderSubmitAdminButton = (row, { props, setErrorMessage }) => {
  return (
    <ProjectSubmitAdmin
      rowData={row}
      mainProps={props}
      setErrorMessage={setErrorMessage}
    />
  )
}
export const renderPrepareMapFormButton = (row, { props, setErrorMessage }) => {
  return (
    <PrepareForMap
      rowData={row}
      mainProps={props}
      setErrorMessage={setErrorMessage}
    />
  )
}
export const renderResetPackageButton = (row, { props, setErrorMessage }) => {
  return (
    <ResetPackage
      rowData={row}
      mainProps={props}
      setErrorMessage={setErrorMessage}
    />
  )
}

export const renderStopGasProjectButton = (row, { props, setErrorMessage }) => {
  return (
    <StopGasProject
      rowData={row}
      mainProps={props}
      setErrorMessage={setErrorMessage}
    />
  )
}
export const renderProjectRequired = (
  params,
  { props, currentUser, userInfo }
) => {
  return params.projectLevelEnum !== 0 ? (
    <ProjectRequired
      rowData={params}
      mainProps={props}
      currentUser={currentUser}
      userInfo={userInfo}
    />
  ) : null
}
export const renderSendToGasButton = (params, { props, setErrorMessage }) => {
  return (
    <ProjectSendToGas
      rowData={params}
      mainProps={props}
      setErrorMessage={setErrorMessage}
    />
  )
}
export const renderDeleteButton = (params, { props }) => {
  return <ProjectDelete rowData={params} mainProps={props} />
}

export const renderEditButton = (params, { props }) => {
  return <ProjectUpdate rowData={params} mainProps={props} />
}

export const renderRowNumber = (index, { pageIndex, pageSize }) => {
  return (
    <Badge
      count={(pageIndex - 1) * pageSize + index + 1}
      style={{
        backgroundColor: "#f0f0f0",
        color: "#595959",
        fontWeight: 500,
        fontSize: 11,
      }}
      overflowCount={9999}
    />
  )
}

// Helper function to get building type color and icon
const getBuildingTypeStyle = buildingType => {
  switch (buildingType) {
    case "تجاری":
      return { color: "cyan", icon: "🏪" }
    case "صنعتی":
      return { color: "orange", icon: "🏭" }
    case "عمومی":
      return { color: "green", icon: "🏛️" }
    case "اداری":
      return { color: "blue", icon: "🏢" }
    default:
      return { color: "default", icon: "🏠" }
  }
}

// Helper function to get piping type style
const getPipingTypeStyle = pipingType => {
  return pipingType === "روکار"
    ? { color: "default", bg: "#fafafa" }
    : { color: "gold", bg: "#fffbe6" }
}

const getHasBurial = hasBurial => {
  return hasBurial
    ? { color: "gray", bg: "#fafafa" }
    : { color: "gold", bg: "#fffbe6" }
}

export const projectColumnsAnt = props =>
  [
    // Index row
    {
      title: "#",
      key: "id",
      render: (id, record, index) => renderRowNumber(index, props),
      width: 50,
      align: "center",
      fixed: "right",
    },
    // File Number
    {
      title: (
        <Space size={4}>
          <FileTextOutlined />
          <span>پرونده</span>
        </Space>
      ),
      key: "fileNumber",
      render: params => (
        <Flex vertical gap={6} align="center" justify="center">
           <Space size={4}>
          <HomeOutlined />
          <span>{params.landlordName}</span>
        </Space>
          {renderEditButton(params, props)}
          <Space size={4}>
            <Tooltip title="مدیریت پرونده">
              <Link
                to={`/projects/GasProjectProcess/${params?.id}`}
                target="_blank"
              >
                <Button
                  type="default"
                  size="small"
                  icon={<ToolOutlined />}
                  style={{ borderRadius: 6 }}
                />
              </Link>
            </Tooltip>
            {params.fileNumber && (
              <Tooltip title="تیکت‌های پرونده">
                <Button
                  type="default"
                  size="small"
                  icon={<CustomerServiceOutlined style={{ color: '#722ed1' }} />}
                  style={{ borderRadius: 6 }}
                  onClick={e => {
                    e.stopPropagation()
                    props.onOpenSupport?.(params.fileNumber)
                  }}
                />
              </Tooltip>
            )}
            {params.fileNumber && (
              <Tooltip title="تاریخچه تغییرات">
                <Button
                  type="default"
                  size="small"
                  icon={<HistoryOutlined style={{ color: '#13c2c2' }} />}
                  style={{ borderRadius: 6 }}
                  onClick={e => {
                    e.stopPropagation()
                    props.onOpenAuditLog?.(params.fileNumber)
                  }}
                />
              </Tooltip>
            )}
            {props.currentUser.role === "Administrator" &&
              renderStopGasProjectButton(params, props)}
          </Space>
        </Flex>
      ),
      width: 140,
      align: "center",
    },
    // Files
    {
      title: (
        <Space size={4}>
          <span>📁</span>
          <span>فایل‌ها</span>
        </Space>
      ),
      key: "File",
      render: params => (
        <Flex vertical gap={6} align="center" justify="center">
          {renderFileButton(params, props)}
          {renderResetPackageButton(params, props)}
        </Flex>
      ),
      width: 85,
      align: "center",
    },
    // Submit Admin
    {
      title: (
        <Space size={4}>
          <span>✓</span>
          <span>تایید</span>
        </Space>
      ),
      key: "submitAdmin",
      render: params => (
        <Flex vertical gap={4} align="center" justify="center">
          {renderSubmitAdminButton(params, props)}
          {renderPrepareMapFormButton(params, props)}
          {params.solarDateExecutorSubmit && <Tag>
              تسویه:{params.solarDateExecutorSubmit}
            </Tag>}
          {renderSendToGasButton(params, props)}
        </Flex>
      ),
      width: 100,
      align: "center",
      hidden:
        props.currentUser.role !== "Administrator" ||
        props.projectLevelFilter !== 2,
    },
    // Project Process
    {
      title: (
        <Space size={4}>
          <span>📋</span>
          <span>تخصیص</span>
        </Space>
      ),
      key: "ProjectProcess",
      render: params => (
        <Flex vertical gap={4} align="center" justify="center">
          {renderProjectProcess(params, props)}
          {renderProjectRequired(params, props)}
        </Flex>
      ),
      width: 110,
      align: "center",
    },
    // Register Date & Types
    {
      title: (
        <Space size={4}>
          <CalendarOutlined />
          <span>ثبت/نوع</span>
        </Space>
      ),
      key: "solarRegisterDate",
      render: row => {
        const buildingStyle = getBuildingTypeStyle(row.buildingType)
        const pipingStyle = getPipingTypeStyle(row.pipingType)
        return (
          <Flex vertical gap={4} align="center">
            <Tag
              style={{
                borderRadius: 6,
                fontSize: 11,
                margin: 0,
                padding: "2px 8px",
              }}
            >
              📅 {row.solarRegisterDate}
            </Tag>
            <Tag
              color={pipingStyle.color}
              style={{
                borderRadius: 6,
                fontSize: 10,
                margin: 0,
              }}
            >
              <ToolOutlined style={{ marginLeft: 4 }} />
              {row.pipingType} {row.hasBurial?(<Text color="brown">دفنی</Text>):''}
            </Tag>
            <Tag
              color={buildingStyle.color}
              style={{
                borderRadius: 6,
                fontSize: 10,
                margin: 0,
              }}
            >
              {buildingStyle.icon} {row.buildingType}
            </Tag>
          </Flex>
        )
      },
      width: 100,
      align: "center",
    },
    // Request Dates
    {
      title: (
        <Space size={4}>
          <span>📆</span>
          <span>درخواست</span>
        </Space>
      ),
      key: "solarPrepareForMapStage",
      render: row => (
        <Flex vertical gap={3} align="stretch">
          <Tooltip title="تاریخ طراحی">
            <Tag
              color={row.isPrepareForDesignStage ? "processing" : "default"}
              style={{
                borderRadius: 6,
                fontSize: 10,
                margin: 0,
                textAlign: "center",
              }}
            >
              طراحی:{" "}
              {row.isPrepareForDesignStage
                ? row.solarPrepareForDesignStage
                : "—"}
            </Tag>
          </Tooltip>
          <Tooltip title="تاریخ نقشه">
            <Tag
              color={row.isPrepareForMapStage ? "success" : "default"}
              style={{
                borderRadius: 6,
                fontSize: 10,
                margin: 0,
                textAlign: "center",
              }}
            >
              نقشه:{" "}
              {row.isPrepareForMapStage ? row.solarPrepareForMapStage : "—"}
            </Tag>
          </Tooltip>
          <Tooltip title="تاریخ رفع نقص">
            <Tag
              color={row.isSolvedDefect ? "warning" : "default"}
              style={{
                borderRadius: 6,
                fontSize: 10,
                margin: 0,
                textAlign: "center",
              }}
            >
              نقص: {row.isSolvedDefect ? row.solarSolvedDefect : "—"}
            </Tag>
          </Tooltip>
        </Flex>
      ),
      width: 110,
      align: "center",
    },
    // Executor Info
    {
      title: (
        <Space size={4}>
          <UserOutlined />
          <span>مجری</span>
        </Space>
      ),
      key: "exeFullName",
      render: row => (
        <Flex vertical gap={4} align="center">
          <Tooltip title="نام مجری">
            <Tag
              color="blue"
              style={{
                borderRadius: 6,
                fontSize: 11,
                margin: 0,
                maxWidth: 100,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              <UserOutlined style={{ marginLeft: 4 }} />
              {row.executor.fullName}
            </Tag>
          </Tooltip>
          <Tooltip title="اعتبار مجری">
            <Tag
              color="green"
              style={{
                borderRadius: 6,
                fontSize: 10,
                margin: 0,
                fontFamily: "tahoma",
              }}
            >
              💰 {getFormattedAmount(row.exeBalance)}
            </Tag>
          </Tooltip>
          <Tooltip title="بالانس پروژه">
            <Tag
              color={row.projectBalance < 0 ? "error" : "success"}
              style={{
                borderRadius: 6,
                fontSize: 10,
                margin: 0,
                fontFamily: "tahoma",
              }}
            >
              <WalletOutlined style={{ marginLeft: 4 }} />
              {getFormattedAmount(row.projectBalance)}
            </Tag>
          </Tooltip>
        </Flex>
      ),
      width: 115,
      align: "center",
    },

    // Address
    {
      title: (
        <Space size={4}>
          <EnvironmentOutlined />
          <span>آدرس</span>
        </Space>
      ),
      key: "address",
      render: params => {
        const addressPart = params.address.split(":")[1] || params.address
        return (
          <Flex vertical gap={4}>
            <Tag
              color="geekblue"
              style={{
                borderRadius: 6,
                fontSize: 10,
                margin: 0,
              }}
            >
              <EnvironmentOutlined style={{ marginLeft: 4 }} />
              {params.cityName} - {params.sectionName}
            </Tag>
            <Tooltip title={addressPart} placement="left">
              <Text
                style={{
                  fontSize: 11,
                  color: "#595959",
                  maxWidth: 140,
                  display: "block",
                  lineHeight: 1.4,
                }}
                ellipsis={{ rows: 2 }}
              >
                {addressPart}
              </Text>
            </Tooltip>
          </Flex>
        )
      },
      width: 150,
    },
    // Unit & Floor
    {
      title: (
        <Space size={4}>
          <BuildOutlined />
          <span>واحد</span>
        </Space>
      ),
      key: "unitNumber",
      render: params => (
        <Flex vertical gap={3} align="center">
          <Tooltip title="تعداد واحد">
            <Tag
              color="blue"
              style={{
                borderRadius: 6,
                fontSize: 10,
                margin: 0,
              }}
            >
              {params.unitNumber} واحد
            </Tag>
          </Tooltip>
          {renderFloorNumber(params)}
          <Tag
            color="purple"
            style={{
              borderRadius: 6,
              fontSize: 9,
              margin: 0,
            }}
          >
            {params.inspectionParameterType}
          </Tag>
        </Flex>
      ),
      width: 75,
      align: "center",
    },
    // Deliver Date
    {
      title: (
        <Space size={4}>
          <span>📤</span>
          <span>تخصیص</span>
        </Space>
      ),
      key: "solarDateDeliverEngineer",
      render: (_, row) => (
        <Tag
          style={{
            borderRadius: 6,
            fontSize: 11,
            background: "#f5f5f5",
          }}
        >
          {row.solarDateDeliverEngineer || "—"}
        </Tag>
      ),
      width: 90,
      align: "center",
    },
    // Serial Number
    {
      title: (
        <Space size={4}>
          <NumberOutlined />
          <span>سریال</span>
        </Space>
      ),
      key: "packageSerialNumber",
      render: (_, row) => (
        <Tooltip title={row.packageSerialNumber}>
          <Tag
            color={row.packageSerialNumber ? "cyan" : "default"}
            style={{
              borderRadius: 6,
              fontSize: 11,
              fontFamily: "tahoma",
            }}
          >
            {row.packageSerialNumber || "—"}
          </Tag>
        </Tooltip>
      ),
      width: 100,
      align: "center",
    },
    // Description
    {
      title: (
        <Space size={4}>
          <span>📝</span>
          <span>توضیحات</span>
        </Space>
      ),
      key: "des1",
      render: (_, row) => (
        <Tooltip title={row.des1} placement="left">
          <Text
            style={{
              fontSize: 11,
              color: "#8c8c8c",
              maxWidth: 100,
              display: "block",
            }}
            ellipsis
          >
            {row.des1 || "—"}
          </Text>
        </Tooltip>
      ),
      width: 110,
    },
  ].filter(x => !x.hidden)
